import { render, staticRenderFns } from "./AccessResetPassword.vue?vue&type=template&id=0cc3f762&scoped=true"
import script from "./AccessResetPassword.vue?vue&type=script&lang=js"
export * from "./AccessResetPassword.vue?vue&type=script&lang=js"
import style0 from "./AccessResetPassword.vue?vue&type=style&index=0&id=0cc3f762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3f762",
  null
  
)

export default component.exports